module.exports = __webpack_public_path__ + "static/media/balance energía 2021.71b77422.png";